/**
 * The methods listed below are global methods available
 *  under $popper.togglePopper(popperButton, popperPopup, customOptions), e.g. this.$popper.togglePopper(popperButton, popperPopup, customOptions)
 *
 *  Code samples and usage are listed in: src/components/Demos/PopperDemo.vue
 *
 *  For more docs and tutorials visit: https://popper.js.org/
 */

import Vue from "vue";
import { createPopper }  from '@popperjs/core';

let popperInstance = null;
let lastUsedPopperPopup = null;


/**
 * Default options are listed below in 'options' var.
 * Other defaults are provided by default by Popper.js, and you can overwrite them if needed to, by passing 'customOptions' object (see notes below in togglePopper() method)
 *
 * If you pass 'customOptions' object, both vars 'object' and 'customOptions' will be merged.
 * If objects have a property with the same name, then the right-most object property overwrites the previous one.
 *
 * For more options and modifiers, visit: https://popper.js.org/docs/v2/modifiers/
 *
 * @type {{placement: string, modifiers: [{name: string}]}}
 */

let options = {
    placement: "bottom-start",
    modifiers: [
        {
            name: 'preventOverflow',
        },
    ]
}

export default {
    /**
     *
     * Main method to be called
     * 'customOptions' object is optional
     * If you pass 'customOptions' object, both 'options' and 'customOptions' object will be merged.
     * If objects have a property with the same name, then the right-most object property overwrites the previous one
     * For more options and modifiers, visit: https://popper.js.org/docs/v2/modifiers/
     *
     * @param popperButton (required)
     * @param popperPopup (required)
     * @param customOptions (optional)
     */
    togglePopper(popperButton, popperPopup, customOptions= {}) {
        // console.log('clicked', popperButton);
        if (popperPopup.hasAttribute("show-popper")) {
            // console.log('has show-popper')
            Vue.popper.hidePopper(popperButton, popperPopup);
        }
        else {
            // console.log('NOT show-popper')
            if(lastUsedPopperPopup !== popperPopup){
                // console.log(`lastPopperPopup: ${JSON.stringify(lastUsedPopperPopup)} popperPopup: ${JSON.stringify(popperPopup)}`)
                Vue.popper.destroyInstance();
            }
            Vue.popper.showPopper(popperButton, popperPopup, customOptions);
        }
    },

    showPopper(popperButton, popperPopup, customOptions){
        popperPopup.setAttribute("show-popper", "");
        Vue.popper.createInstance(popperButton, popperPopup, {...options, ...customOptions});
        lastUsedPopperPopup = popperPopup;
    },

    hidePopper(popperButton, popperPopup){
        popperPopup.removeAttribute("show-popper");
        Vue.popper.destroyInstance();
    },

    createInstance(popperButton, popperPopup, options){
        popperInstance = createPopper(popperButton, popperPopup, options);
    },

    destroyInstance(){
        // console.log('destroyInstance');
        if (popperInstance) {
            popperInstance.destroy();
            popperInstance = null;
            lastUsedPopperPopup.removeAttribute("show-popper");
            lastUsedPopperPopup = null;
        }
    },
}